import React, { Component } from 'react'; // eslint-disable-line

class ManagedInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentValue: '',
            inputValue: !props.value ? '' : props.value,
        };

        this.onChangeFn = this.onChangeFn.bind(this);
        this.onBlurFn = this.onBlurFn.bind(this);
        this.onFocusFn = this.onFocusFn.bind(this);
        this.onKeyDownFn = this.onKeyDownFn.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value && this.props.value !== prevState.inputValue) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                inputValue: !this.props.value ? '' : this.props.value,
            });
        }
        if ((this.props.menuTitle && prevState.inputValue.length < 1 && this.state.inputValue.length < 1 && this.props.value) || (this.props.menuTitle && this.state.inputValue.length < 1 && this.props.value?.length > 1)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                inputValue: this.props.value,
            });
        }
    }

    onChangeFn(e) {
        const currentValue = this.state.inputValue;

        if (this.state.currentValue === '') {
            this.setState({
                inputValue: e.target.value,
                currentValue,
            });
        } else {
            this.setState({
                inputValue: e.target.value,
            });
        }

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    onBlurFn(e) {
        e.oldValue = this.state.currentValue;

        if (this.props.onBlur && !this.waitingOnFinishTyping) {
            this.props.onBlur(e);
        }
    }

    onFocusFn(e) {
        this.setState({ currentValue: e.target.value });
    }

    onKeyDownFn(e) {
        if (e.keyCode === 13 && this.props.onReturnDown && !this.waitingOnFinishTyping) {
            this.props.onReturnDown(e);
        }
    }

    render() {
        let {
            successErrorClass,
            name,
            type,
            placeholder,
            multiline,
            onFocus,
            maxLength,
            className,
            autoFocus,
            id,
            disabled,
            refInput,
            autoComplete
        } = this.props;
        const dataqa = this.props.dataqa ? this.props.dataqa : this.props.id;
        type = !type ? 'text' : type;
        className = successErrorClass ? `${className} ${successErrorClass}` : className;
        let inputElement = (
            <input
                ref={refInput}
                type={type}
                onFocus={onFocus}
                onKeyDown={this.onKeyDownFn}
                name={name}
                value={this.state.inputValue}
                onBlur={this.onBlurFn}
                onChange={this.onChangeFn}
                // onFocus={this.onFocusFn}
                maxLength={maxLength}
                placeholder={placeholder}
                className={className}
                id={id}
                disabled={`${disabled ? 'disabled' : ''}`}
                data-qa={dataqa}
                autoComplete={autoComplete}
            />
        );

        if (autoFocus) {
            inputElement = (
                <input
                    ref={refInput}
                    type={type}
                    onFocus={onFocus}
                    onKeyDown={this.onKeyDownFn}
                    name={name}
                    value={this.state.inputValue}
                    onBlur={this.onBlurFn}
                    onChange={this.onChangeFn}
                    // onFocus={this.onFocusFn}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    className={className}
                    autoFocus // eslint-disable-line
                    data-qa={dataqa}
                />
            );
        }

        if (multiline) {
            inputElement = (
                <textarea
                    ref={refInput}
                    maxLength={maxLength}
                    onChange={this.onChangeFn}
                    placeholder={placeholder}
                    onFocus={this.onFocusFn}
                    name={name}
                    onBlur={this.onBlurFn}
                    // onFocus={this.onFocusFn}
                    value={this.state.inputValue}
                    data-qa={dataqa}
                    id={id}
                />
            );
        }

        return (inputElement);
    }
}

export default ManagedInput;
